import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./Components/Home";
import Services from "./Components/Services";
import BookAppointment from "./Components/BookAppointment";
import Contactpage from "./Components/Contactpage";
import ServicesPage from "./Components/ServicesPage";
import BookAppointmentpage from "./Components/BookAppointpage";


function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route path="/" component={Home} exact />
          <Route path='/services' component={ServicesPage} exact/>
          <Route path='/book-appointment' component={BookAppointmentpage} exact/>
          <Route path='/contact' component={Contactpage} exact/>
          

          

        </Switch>
      </Router>
    </>
  );
}
export default App;
